import React, { useEffect } from "react";

type Props = {};

export const marketAndroid = "market://details?id=com.hi.pineapple";
export const marketIos = "https://itunes.apple.com/app/id1521407322";
export const downloadApp = "https://sandimall.com/product/%EC%83%8C%EB%94%94-app/01tJ1000000r4aTIAQ";

export default function AppInstall(props: Props) {
  const launchAppUrl = "sandiapp://"; // 앱 스키마
  let timer: NodeJS.Timeout;
  let schInterval: NodeJS.Timeout;

  let currentOS: string;
  const mobile = /iphone|ipad|ipod|android/i.test(
    navigator.userAgent.toLowerCase()
  );

  if (mobile) {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.search("android") > -1) currentOS = "android";
    else if (
      userAgent.search("iphone") > -1 ||
      userAgent.search("ipod") > -1 ||
      userAgent.search("ipad") > -1
    )
      currentOS = "ios";
    else currentOS = "other";
  } else {
    currentOS = "nomobile";
  }

  const checkAppInstall = () => {
    if (currentOS === "android") {
      window.location.href = marketAndroid;
    } else if (currentOS === "ios") {
      window.location.href = launchAppUrl;
      schInterval = setInterval(intervalSch, 500);
      timer = setTimeout(() => {
        window.location.href = marketIos;
        clearInterval(schInterval);
      }, 2000);
    } else {
      window.location.href = downloadApp;
    }
  };

  const clearTimer = () => {
    clearInterval(schInterval);
    clearTimeout(timer);
  };

  const intervalSch = () => {
    if ((document as any).webkitHidden || document.hidden) {
      clearTimer();
    }
  };

  useEffect(() => {
    checkAppInstall();
  }, []);

  return <div></div>;
}
